import React, { useState } from 'react';
import { Group, Button, Menu, Modal, Text, Box, ActionIcon, Badge } from '@mantine/core';
import { useDisclosure } from '@mantine/hooks';
import {
  IconHeart,
  IconHeartFilled,
  IconShare,
  IconDotsVertical,
  IconCalendarPlus,
  IconBookmark,
  IconUserPlus,
  IconEdit,
  IconPlayerPlay,
  IconCopy,
} from '@tabler/icons-react';

interface InteractionButtonsProps {
  context: string[];
  postId?: number;
  likeCount?: number;
  isLiked?: boolean;
  isUserSignedIn: boolean;
  isAuthor?: boolean;
  isSuperAdmin?: boolean;
  object?: any;
  onLike?: (postId: number) => void;
}

const InteractionButtons: React.FC<InteractionButtonsProps> = ({
  context = [],
  postId,
  likeCount = 0,
  isLiked = false,
  isUserSignedIn = false,
  isAuthor = false,
  isSuperAdmin = false,
  object,
  onLike,
}) => {
  const [liked, setLiked] = useState(isLiked);
  const [likes, setLikes] = useState(likeCount);
  const [opened, { open, close }] = useDisclosure(false);

  const handleLike = () => {
    if (!isUserSignedIn) return;

    if (onLike && postId) {
      onLike(postId);
    }

    setLiked(!liked);
    setLikes(liked ? likes - 1 : likes + 1);
  };

  return (
    <Box
      style={(theme) => ({
        display: 'flex',
        alignItems: 'center',
        gap: theme.spacing.md,

        paddingLeft: theme.spacing.xl,
        borderRadius: theme.radius.md,
        padding: theme.spacing.sm,
        boxShadow: '0px 2px 2px rgba(0, 0, 0, 0.03)',
        backgroundColor: '#17171790',
        '&:hover': {
          boxShadow: '0px 4px 4px rgba(0, 0, 0, 0.01)',
          transition: 'box-shadow 0.3s ease-in-out',
        },
      })}
    >
      {/* Like Counter */}
      {context.includes('post') && (
        <>
          {isUserSignedIn ? (
            <Group gap="xs">
              <ActionIcon variant="subtle" color="#EA580C" onClick={handleLike} data-post-id={postId} size="lg">
                {liked ? <IconHeartFilled size={24} color="red" /> : <IconHeart size={24} color="red" />}
              </ActionIcon>
              <Text size="sm">{likes}</Text>
            </Group>
          ) : (
            <Button variant="filled" color="#EA580C" component="a" href="/login">
              Like
            </Button>
          )}
        </>
      )}

      {/* Share Button */}
      <Button variant="outline" color="#EA580C" leftSection={<IconShare size={18} />} onClick={open}>
        Share
      </Button>

      {/* More Button */}
      {/* <Menu position="bottom-end" shadow="md">
        <Menu.Target>
          <ActionIcon variant="subtle">
            <IconDotsVertical size={18} />
          </ActionIcon>
        </Menu.Target>

        <Menu.Dropdown>
          {context.includes('event') && (
            <>
              <Menu.Item component="a" href={`/events/${object?.id}`}>
                View Event Details
              </Menu.Item>
              <Menu.Item leftSection={<IconCalendarPlus size={16} />}>Add to Calendar</Menu.Item>
            </>
          )}

          {context.includes('artist') && (
            <>
              <Menu.Item component="a" href={`/artists/${object?.id}`}>
                View Artist Profile
              </Menu.Item>
              <Menu.Item leftSection={<IconUserPlus size={16} />}>Follow Artist</Menu.Item>
            </>
          )}

          {context.includes('blog') && (
            <>
              {isUserSignedIn && (isSuperAdmin || isAuthor) && (
                <Menu.Item leftSection={<IconEdit size={16} />} component="a" href={`/posts/${postId}/edit`}>
                  Edit Post
                </Menu.Item>
              )}
              <Menu.Item leftSection={<IconBookmark size={16} />}>Bookmark Post</Menu.Item>
              <Menu.Item leftSection={<IconUserPlus size={16} />}>Subscribe To Author</Menu.Item>
            </>
          )}

          {context.includes('podcast') && (
            <>
              <Menu.Item leftSection={<IconPlayerPlay size={16} />} component="a" href={`/podcasts/${object?.id}`}>
                Listen Now
              </Menu.Item>
              <Menu.Item leftSection={<IconUserPlus size={16} />}>Subscribe</Menu.Item>
            </>
          )}

          {context.length === 0 && <Menu.Item>View Details</Menu.Item>}
        </Menu.Dropdown>
      </Menu> */}

      {/* Share Modal */}
      <Modal opened={opened} onClose={close} title="Share Post">
        <Text>Share this on:</Text>
        <Group justify="apart" my="md">
          <Button variant="filled" color="orange">
            Twitter
          </Button>
          <Button variant="filled" color="orange">
            Facebook
          </Button>
          <Button variant="filled" color="orange">
            LinkedIn
          </Button>
        </Group>
        <Text mt="md">Or copy the link:</Text>
        <Group mt="xs">
          <Button
            variant="light"
            color="orange"
            leftSection={<IconCopy size={16} />}
            onClick={() => {
              navigator.clipboard.writeText(window.location.href);
            }}
          >
            Copy
          </Button>
        </Group>
      </Modal>
    </Box>
  );
};

export default InteractionButtons;
